import { fetch } from '@/utils/request';

// 订单
const orderIndex = (param, callback) => fetch('/shop/order/index','GET', param, callback); //列表
const orderDetail = (param, callback) => fetch('/shop/order/detail','GET', param, callback); //详情
const orderCancel = (param, callback) => fetch('/shop/order/cancel','POST', param, callback); //取消
const orderDelivery = (param, callback) => fetch('/shop/order/delivery','POST', param, callback); //发货
// const orderSetump = (param, callback) => fetch('/shop/order/setump','POST', param, callback);
// const orderInvoice = (param, callback) => fetch('/shop/order/invoice','POST', param, callback);
// const orderShipmentsLog = (param, callback) => fetch('/shop/order/shipments/log','GET', param, callback);
const orderHexiao = (param, callback) => fetch('/shop/order/hexiao','POST', param, callback); //核销
const orderSelffetchLog = (param, callback) => fetch('/shop/order/selffetch/log','GET', param, callback); //上门自提记录
const orderDeliveryLog = (param, callback) => fetch('/shop/order/delivery/log','GET', param, callback); //订单物流信息
const orderHoldIndex = (param, callback) => fetch('/shop/order/hold/index','GET', param, callback); //挂单列表
const orderHoldSave = (param, callback) => fetch('/shop/order/hold/save','POST', param, callback); //保存挂单
const orderHoldRestore = (param, callback) => fetch('/shop/order/hold/restore','POST', param, callback); //恢复挂单
const orderHoldDelete = (param, callback) => fetch('/shop/order/hold/delete','POST', param, callback); //删除挂单
const cashierOrderCreate = (param, callback) => fetch('/shop/cashier/order/create','POST', param, callback); //收银台下单
const cashierPayQuery = (param, callback) => fetch('/shop/cashier/order/payQuery','POST', param, callback); //收银台支付查询

// 退款
const refundDetail = (param, callback) => fetch('/shop/refund/detail','GET', param, callback); //详情
const refundAgree = (param, callback) => fetch('/shop/refund/agree','POST', param, callback); //退款同意/拒绝
const refundClose = (param, callback) => fetch('/shop/refund/close','POST', param, callback); //关闭退款
const refundSure = (param, callback) => fetch('/shop/refund/sure','POST', param, callback); //确认收货

// 交易
const orderTradeTjIndex = (param, callback) => fetch('/shop/order/trade/tj/index','GET', param, callback); //交易统计
const orderTradeRecharge = (param, callback) => fetch('/shop/order/trade/recharge','GET', param, callback); //充值列表
const orderTradeIndex = (param, callback) => fetch('/shop/order/trade/index','GET', param, callback); //交易列表
const orderTradeTjTime = (param, callback) => fetch('/shop/order/trade/tj/time','GET', param, callback); //订单交易统计

// 提现
const financeWithdrawIndex = (param, callback) => fetch('/shop/finance/withdraw/index','GET', param, callback); //提现列表
const financeWithdrawOperate = (param, callback) => fetch('/shop/finance/withdraw/operate','POST', param, callback); //提现操作

// 发票
const financeInvoiceIndex = (param, callback) => fetch('/shop/finance/invoice/index','GET', param, callback); //列表
const financeInvoiceIssue = (param, callback) => fetch('/shop/finance/invoice/issue','POST', param, callback); //开票
const financeInvoiceRefund = (param, callback) => fetch('/shop/finance/invoice/refund','POST', param, callback); //退票

export default {
    orderIndex,
    orderDetail,
    orderDeliveryLog,
    orderCancel,
    orderDelivery,
    orderHexiao,
    orderSelffetchLog,
    orderHoldIndex,
    orderHoldSave,
    orderHoldRestore,
    orderHoldDelete,
    cashierOrderCreate,
    cashierPayQuery,
    refundDetail,
    refundAgree,
    refundClose,
    refundSure,
    // orderSetump,
    // orderInvoice,
    // orderShipmentsLog
    orderTradeTjIndex,
    orderTradeRecharge,
    orderTradeIndex,
    orderTradeTjTime,
    financeWithdrawIndex,
    financeWithdrawOperate,
    financeInvoiceIndex,
    financeInvoiceIssue,
    financeInvoiceRefund
}
